import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { isEmpty } from 'helpers/string.helper';
import './PlusOverviewBannerModule.scss';
import { PlusOverviewBannerCustomHtmlView } from './components/PlusOverviewBannerCustomHtmlView';
import { PlusOverviewBannerModuleView } from './components/PlusOverviewBannerModuleView';
import { getFeatureNavigationUrl } from 'pages/PlusLanding/helpers/plus.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { PLUS_BANNER_OFFER_MODULE } from './PlusOverviewBannerModule.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import classnames from 'classnames';
import { useSubscriptionLandingUrl } from 'hook/subscriptionLandingUrl.hook';

const PrimaryPlusOverviewBannerModuleView = props => {
  const { isCustomHtmlView, isTwoModules } = props ?? {};

  if (isCustomHtmlView) {
    return (
      <PlusOverviewBannerCustomHtmlView
        {...props}
        isTwoModules={isTwoModules}
      />
    );
  } else {
    return (
      <PlusOverviewBannerModuleView {...props} isTwoModules={isTwoModules} />
    );
  }
};

const PlusOverviewBannerModuleController = props => {
  const {
    history,
    eventHandler,
    plusBannerOverviewWebConfig,
    modulePosition,
    isTwoModules,
  } = props;
  const { subscriptionLandingUrl } = useSubscriptionLandingUrl();
  const { htmlConfig, cta, disclaimer, featureNavigation } =
    plusBannerOverviewWebConfig?.mainJson ?? {};

  const isCustomHtmlView = !isEmpty(htmlConfig);

  const goToPremium = () => {
    const finalUrl = featureNavigation
      ? subscriptionLandingUrl +
        '?feature=' +
        getFeatureNavigationUrl(featureNavigation)
      : subscriptionLandingUrl;
    eventHandler(CLICK, {
      'Click Type': 'Plus Banner Offer CTA',
    });
    history.push(finalUrl);
  };

  const ctaConfig = {
    ctaText: cta,
    disclaimer: disclaimer,
    onClickCta: goToPremium,
  };

  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: PLUS_BANNER_OFFER_MODULE,
    modulePosition,
    vertical: SUBSCRIPTION_VERTICAL,
  });

  const seenPixel = useSeenModulePixel(trackingAtr);

  const plusOverviewBannerClass = classnames(
    'PlusOverviewBannerModule bgWhite  m-padLR18 grayShadow16 border-rad8px pos-rel flex-1',
    {
      'padL32 padR44 padTB26': !isTwoModules,
      'padLR18 padT26 padB14': isTwoModules,
    },
  );

  return (
    <>
      <FlexContainer column className={plusOverviewBannerClass}>
        {seenPixel}
        <PrimaryPlusOverviewBannerModuleView
          isCustomHtmlView={isCustomHtmlView}
          copyConfig={plusBannerOverviewWebConfig?.mainJson}
          onClickCta={goToPremium}
          ctaConfig={ctaConfig}
          isTwoModules={isTwoModules}
        />
      </FlexContainer>
    </>
  );
};

export default PlusOverviewBannerModuleController;
